import React from 'react'
import { Row, Col } from 'antd'
import styled from 'styled-components'

const TableRe = ({ col, data }) => {
  const splitText = (text) => {
    let newText = text.split('ตัวอย่างที่ ')
    return newText[1]
  }

  const renderData3 = () => {
    return (
      <Row className='row-table'>
        {data &&
          data?.detail.map((item, index) => {
            return (
              <>
                <Col
                key={index}
                  span={5}
                  style={{
                    borderRight: '2px solid #fff',
                  }}
                >
                  <Source font="Noto Sans Thai Bold" align="center" color='#FFF9EA'>
                    {index % 2 !== 0 && (
                      <>
                        ตัวอย่าง
                        {/* <Exam>{splitText(data?.titel)}</Exam> */}
                      </>
                    )}
                  </Source>
                </Col>
                <Col
                  span={4}
                  style={{
                    borderRight: '2px solid #fff',
                  }}
                >
                  <Source font="Noto Sans Thai Bold" align="right" color={index % 2 === 0 ? '#FFF9EA' : '#fff'}>
                    {item?.title}
                  </Source>
                </Col>
                <Col span={5} style={{ borderLeft: '2px solid #fff' }}>
                  <Source color={index % 2 === 0 ? '#FFF9EA' : '#fff'}>
                    {item?.year_1_1}
                  </Source>
                </Col>
                <Col span={5}>
                  <Source color={index % 2 === 0 ? '#FFF9EA' : '#fff'}>
                    {item?.year_1_2}
                  </Source>
                </Col>
                <Col span={5} style={{ borderRight: '2px solid #fff' }}>
                  <Source color={index % 2 === 0 ? '#FFF9EA' : '#fff'}>
                    {item?.title === "GPAX" ? "1.47": item?.title === "สถานภาพ" ? "พ้นสถานภาพ" :item?.year_1_3 }

                  </Source>
                </Col>
                {/* <Col span={3} style={{ borderLeft: '2px solid #fff' }}>
                  <Source color={index % 2 === 0 ? '#FFF9EA' : '#fff'}>
                    {item?.year_2_1}
                  </Source>
                </Col>
                <Col span={3}>
                  <Source color={index % 2 === 0 ? '#FFF9EA' : '#fff'}>
                    {item?.year_2_2}
                  </Source>
                </Col>
                <Col span={3}>
                  <Source color={index % 2 === 0 ? '#FFF9EA' : '#fff'}>
                    {item?.year_2_3}
                  </Source>
                </Col> */}
              </>
            )
          })}
      </Row>
    )
  }

  const renderColumn = () => {
    return (
      <Row className='row-table'>
        <Col span={3} />
        <Col span={3} />

        <Col span={3} style={{ backgroundColor: '#FAA378' }} />
        <Col span={3} style={{ backgroundColor: '#FAA378' }}>
          <Column>ปี 1</Column>
        </Col>
        <Col
          span={3}
          style={{ backgroundColor: '#FAA378', borderRight: '2px solid #fff' }}
        />

        <Col
          span={3}
          style={{ backgroundColor: '#FAA378', borderLeft: '2px solid #fff' }}
        />
        <Col span={3} style={{ backgroundColor: '#FAA378' }}>
          <Column>ปี 2</Column>
        </Col>
        <Col span={3} style={{ backgroundColor: '#FAA378' }} />
      </Row>
    )
  }

  return (
    <Container>
      <div style={{ width: 'auto' }}>
        {col && renderColumn()}
        {renderData3()}
      </div>
    </Container>
  )
}

export default TableRe

export const Container = styled.div`
  overflow-x: scroll;
  overflow-y: hidden;
  margin-bottom: 4px;

  .row-table {
    width: 100%;
    @media only screen and (max-width: 667px) {
      width: 667px !important;
    }

    @media only screen and (max-width: 820px) {
      width: 820px;
    }
  }
`

export const Column = styled.p`
  font-family: 'Noto Sans Thai Bold';
  line-height: 30px;
  font-size: clamp(16px, 2vw, 30px);
  text-align: center;
  color: var(--black);
  padding: 10px;
  margin: 0;
  
`

export const Source = styled.p`
  line-height: 25px;
  font-size: clamp(12px, 2vw, 24px);
  margin: 0;
  color: var(--black);
  min-height: 100%;
  padding: 10px;
  background-color: ${(props) => (props.color ? props.color : 'var( --white)')};
  font-family: ${(props) => (props.font ? props.font : 'Noto Sans Thai')};
  text-align: ${(props) => (props.align ? props.align : 'left')};
`

export const Exam = styled.span`
  font-family: 'Brevia Light Italic';
  font-size: clamp(30px, 2vw, 60px);
  margin-left: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
`
